import { Link } from "react-router-dom";
import styled from "styled-components";

export const ShelfSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 28px;
  border-radius: 24px;
  background:
    radial-gradient(
      circle at top left,
      rgba(var(--color-brand-400-rgb), 0.14),
      transparent 34%
    ),
    rgba(var(--glass-white-rgb), 0.03);
  border: 1px solid rgba(123, 215, 255, 0.14);

  @media (max-width: 768px) {
    padding: 22px;
    border-radius: 20px;
  }
`;

export const ShelfHeader = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 18px;
  align-items: end;

  @media (max-width: 920px) {
    grid-template-columns: 1fr;
  }
`;

export const ShelfCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ShelfEyebrow = styled.p`
  margin: 0;
  font-size: 0.88rem;
  color: var(--color-text-soft);
  text-transform: uppercase;
  letter-spacing: 0.11em;
`;

export const ShelfTitle = styled.h2`
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: clamp(1.65rem, 2.6vw, 2.35rem);
  line-height: normal;
  letter-spacing: -0.03em;
  color: var(--color-text-strong);
`;

export const ShelfText = styled.p`
  margin: 0;
  color: rgba(var(--glass-pale-rgb), 0.8);
  font-size: 1.02rem;
  line-height: normal;
  max-width: 760px;
`;

export const ShelfLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 0 20px;
  border-radius: 999px;
  color: var(--color-brand-200);
  background: rgba(var(--color-brand-400-rgb), 0.14);
  border: 1px solid rgba(123, 215, 255, 0.18);
  text-decoration: none;
  font-weight: 700;
  font-size: 0.98rem;
  white-space: nowrap;
  transition:
    transform 0.2s ease,
    background-color 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    background: rgba(var(--color-brand-400-rgb), 0.22);
  }
`;

export const ShelfGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const LoadingGrid = styled(ShelfGrid)``;

export const LoadingCard = styled.div`
  aspect-ratio: 0.78;
  border-radius: 16px;
  background: linear-gradient(
    90deg,
    rgba(var(--glass-white-rgb), 0.04) 0%,
    rgba(var(--glass-white-rgb), 0.08) 50%,
    rgba(var(--glass-white-rgb), 0.04) 100%
  );
  background-size: 240px 100%;
  animation: shelfShimmer 1.4s linear infinite;

  @keyframes shelfShimmer {
    from {
      background-position: -240px 0;
    }

    to {
      background-position: 240px 0;
    }
  }
`;
